import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';

function DateTimeField(props) {
  const { label } = props.attribute;

  const { placeholderText, dateFormat, showTimeInput } = props;

  useEffect(() => {
    if (props.value) {
      setValue(dayjs(props.value).toDate());
    }
  }, [props.value]);

  const [value, setValue] = useState(null);

  /**
   * @description This method gets triggered on change in date/datetime field
   * emits the selected date or null(if reset) to the parent component
   * @param {Object | null} - newValue
   * @return {void}
   */
  const handleChange = (newValue) => {
    setValue(newValue);
    if (showTimeInput) {
      props.handleChange(
        newValue instanceof Date
          ? dayjs(newValue).format('YYYY-MM-DDTHH:mm')
          : null
      );
    } else {
      props.handleChange(
        newValue instanceof Date ? dayjs(newValue).format('YYYY-MM-DD') : null
      );
    }
  };

  return (
    <div className="w100">
      <div>{label}</div>
      <DatePicker
        label={label}
        selected={value}
        onChange={handleChange}
        placeholderText={placeholderText}
        dateFormat={dateFormat}
        showTimeInput={showTimeInput}
        portalId="root-portal"
        popperPlacement="auto"
      />
    </div>
  );
}

export default DateTimeField;
